export * from "./listagem-produtos.component";
